import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatButtonModule, MatProgressBarModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatTooltipModule, MatCardModule } from '@angular/material';

import { WebviewRoutingModule } from './webview-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { CalendarModule } from 'app/shared/components/calendario/calendar.module';

import { PipeModule } from 'app/core/pipes/pipes.module';
import { CoreModule } from 'app/core/core.module';

import { WebviewCartaoGestanteComponent } from './subpages/webview-cartao-gestante/webview-cartao-gestante.component';
import { WebviewEncerrarCartaoComponent } from './subpages/webview-encerrar-cartao/webview-encerrar-cartao.component';
import { ModalAdicionarExameComponent } from './components/modal-adicionar-exame/modal-adicionar-exame.component';

import { RbFabSpeedDialModule } from 'rb-fab-speed-dial';

@NgModule({
    declarations: [
        WebviewCartaoGestanteComponent, 
        WebviewEncerrarCartaoComponent,
        ModalAdicionarExameComponent,
    ],

    imports: [
        CommonModule,
        WebviewRoutingModule,
        SharedModule,
        CalendarModule,
        CoreModule,
        PipeModule,

        /** FormsModule */
        FormsModule,
        ReactiveFormsModule,

        RbFabSpeedDialModule,

        /** Angular material */
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatCardModule,
    ],

    entryComponents: [
        ModalAdicionarExameComponent,
        WebviewEncerrarCartaoComponent,
    ]
})
export class WebviewModule { }
